import React, { useEffect, useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Spinner } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";

import "./Components/Resources/Fonts/MetricHPE-Web-Bold.woff";
import "./Components/Resources/Fonts/MetricHPE-Web-Medium.woff";
import "./Components/Resources/Fonts/MetricHPE-Regular.ttf";
import "./Components/Resources/Fonts/MetricHPE-Web-Semibold.woff";
import "./Components/Resources/Fonts/MetricHPE-Web-Thin.woff";

import RoutesComponent from "./Routes";
import { ToastContainer, toast } from "react-toastify";
import { AppContext, UPDATE_STATE } from "./AppContext";
import "react-toastify/dist/ReactToastify.css";
import { getURL_GetUserLoginTime, ParticipantSignIn, UserTracker } from "./Components/services/apiFunctions";
import { axiosClient } from "./URLConfig";
import { useNavigate } from "react-router-dom";
import { SignIn } from "./Components/UserTrackingConstants";
const App = () => {
  const [data, dispatch] = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage.getItem("userSessionId")) {
      let userSessionId = uuidv4();
      sessionStorage.setItem("userSessionId", userSessionId);
    }
    if (sessionStorage.getItem("userid") != null) {
      dispatch({
        type: UPDATE_STATE,
        payload: {
          userName: sessionStorage.getItem("name"),
          userid: sessionStorage.getItem("userid"),
          userEmail: sessionStorage.getItem("email"),
          is_Organizer: sessionStorage.getItem("is_Organizer"),
          isLoggedIn: true,
          userempid: sessionStorage.getItem("empId"),
          projectId: sessionStorage.getItem("projectId"),
          userRoles: sessionStorage.getItem("userRoles").split(","),
          userEvents: sessionStorage.getItem("userEvents"),
          CurrentEvent: sessionStorage.getItem("CurrentEvent"),
          isLoggingIn: false, 
        },
      });
    }else {
    dispatch({
      type: UPDATE_STATE,
      payload: {
        isLoggingIn: false,
      },
    });
  }
  }, []);

  useEffect(() => {
    console.log("session login 1");
    // user login
    processAfterLogin();
    if(sessionStorage.getItem("name") == null) {
      signInIfRegistered();
    }
  }, []);

  const signInIfRegistered = async () => {
    try {
      const payload = {
        Email: localStorage.getItem("email"),
      };
      const response = await ParticipantSignIn(payload);
      if (response.status == 200) {
        if (response.data.isRegistered) {
          const UserTrackerPyload = {
            data: JSON.stringify(payload),
            Host: window.location.href,
            Type: SignIn,
            CreatedById: response.data.empId,
          };

          console.log("UserTrackerPyload", UserTrackerPyload);
          const UserTrackerresponse = await UserTracker(UserTrackerPyload);
          console.log("UserTrackerresponse", UserTrackerresponse);
          let userRoles = [];

          response.data.userRoles.forEach((userRole) => {
            userRoles.push(userRole.role.rolecode);
          });
          let userEvents = [];
          response.data.userEvents.forEach((userEvent) => {
            const obj = {
              id: userEvent.eventId,
              Name: userEvent.event.name,
            };

            userEvents.push(obj);
          });
          console.log("userEvent", userEvents);
          console.log("eventid", process.env.REACT_APP_DEFAULT_EVENTID)
          sessionStorage.setItem("email", response.data.email);
          sessionStorage.setItem("userid", response.data.userid);
          sessionStorage.setItem("name", response.data.name);
          sessionStorage.setItem("is_Organizer", response.data.is_Organizer);
          sessionStorage.setItem("empId", response.data.empId);
          sessionStorage.setItem("userRoles", userRoles);
          sessionStorage.setItem("userEvents", JSON.stringify(userEvents));
          sessionStorage.setItem(
            "CurrentEvent",
            JSON.stringify({
              id: process.env.REACT_APP_DEFAULT_EVENTID,
              Name: "Hackathon",
            })
          );

          dispatch({
            type: UPDATE_STATE,
            payload: {
              userName: sessionStorage.getItem("name"),
              userid: sessionStorage.getItem("userid"),
              userEmail: sessionStorage.getItem("email"),
              is_Organizer: sessionStorage.getItem("is_Organizer"),
              userempid: sessionStorage.getItem("empId"),
              isLoggedIn: true,
              userRoles: sessionStorage.getItem("userRoles").split(","),
              userEvents: sessionStorage.getItem("userEvents"),
              CurrentEvent: sessionStorage.getItem("CurrentEvent"),
              isLoggingIn:false
            },
          });

          if (window.location.pathname === "/") {
            setTimeout(() => {
              navigate("/home");
            }, 2000);
          }
        } else {
          const registerPayload = {
            Name: localStorage.getItem("name"),
            Email: localStorage.getItem("email"),
            isTermsAccepted: true,
            Skills: [],          // Optional
            imagePath: "",       // Optional
            cvPath: ""           // Optional
          };

          const registerResponse = await axiosClient.post("/Account/Register", registerPayload);
          if (registerResponse.status === 200 && registerResponse.data?.Userid) {
            // After successful registration, try logging in again
            console.log("YOU ARE REGISTERED")
            await signInIfRegistered();
          } else {
            // toast.error("Auto-registration failed. Please try manually.");
            //navigate("/participant-sign-up");
          }

        }
      } else {
        toast.error(response.data);
        console.log("response", response);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const isPlannedOutage = (empNum) => {
    return false;
  };

  const logoutCurrentUserLoginSession = () => {

    localStorage.removeItem("name");
    localStorage.removeItem("country");
    localStorage.removeItem("empNumber");
    localStorage.removeItem("mail");
    localStorage.removeItem("authorization");
    localStorage.removeItem("isAuthorized");
    localStorage.removeItem("userRoles");
    localStorage.removeItem("joinedDate");
    localStorage.removeItem("LoggedInTime");
    localStorage.removeItem("isUserLoggedIn");
    localStorage.removeItem("profilePhotoUrl");

  };

  // check whether user session is within 24 hrs
  const sessionTimeOut = async () => {
    var epochLS = localStorage.getItem("LoggedInTime");

    var begin = epochLS != null ? parseInt(epochLS) : 0;
    // var epochDate = envData !== "PROD" ? begin + 1800 : begin + 86400;
    var epochDate = begin + 86400;
    const now = new Date();
    //const ew = Math.floor(now.getTime() / 1000);
    // let getUserLoginTimeURL = await getURL_GetUserLoginTime();
    let ew = await getURL_GetUserLoginTime();
    ew = ew.data;
    console.log("session login time 2", ew);

    if (!(begin < ew && ew < epochDate)) {
      // remove user session from LS
      localStorage.removeItem("name");
      localStorage.removeItem("country");
      localStorage.removeItem("empNumber");
      localStorage.removeItem("authorization");
      localStorage.removeItem("isAuthorized");
      localStorage.removeItem("mail");
      localStorage.removeItem("userRoles");
      localStorage.removeItem("joinedDate");
      localStorage.removeItem("LoggedInTime");
      localStorage.removeItem("isUserLoggedIn");
      localStorage.removeItem("profilePhotoUrl");

      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
      window.location.href = process.env.REACT_APP_AUTH_URL;
      return;
    }
  };

  const processUserLogin = () => {
    console.log("session login 12");
    logoutCurrentUserLoginSession();
    if (localStorage.getItem("userSessionId")) {
      console.log("session login 13");
      localStorage.removeItem("userSessionId");
    }
    //redirect for Auth
    window.location.href = process.env.REACT_APP_AUTH_URL;
  };

  const processAfterLogin = async () => {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("redirect")) {
      console.log("session login 16")
      //save redirect param
      var encodedURL = encodeURIComponent(
        urlParams.get("redirect").split("searchValue=")[1]
      );

      localStorage.setItem(
        "redirect",
        urlParams.get("redirect").split("searchValue=")[0] +
        "searchValue=" +
        encodedURL
      );
      localStorage.setItem("redirectionTriggered", true);
    } else if (
      window.location.origin + "/" !== window.location.href &&
      localStorage.getItem("redirectionTriggered") === null
    ) {
      console.log("session login 17")
      localStorage.setItem("redirect", window.location.href);
      localStorage.setItem("redirectionTriggered", true);
    }
    if (urlParams.has("u") && localStorage.getItem("empNumber") === null) {
      console.log("session login 2");
      let userSessionId = uuidv4();
      if (localStorage.getItem("userSessionId")) {
        console.log("session login 19");
        localStorage.removeItem("userSessionId");
      }
      localStorage.setItem("userSessionId", userSessionId);
      // Detect User
      let jwtAuthorization = urlParams.get("u");
      localStorage.setItem("authorization", "Bearer " + jwtAuthorization);
      const decodedToken = jwtDecode(jwtAuthorization);
      console.log("decodedToken", decodedToken);
      //var encoded = Buffer.from(urlParams.get("u"), "base64").toString();
      urlParams = new URLSearchParams(decodedToken);
      console.log("urlParams", urlParams.values());
      var empNumber = urlParams.get("empNumber");
      localStorage.setItem("empNumber", empNumber);

      var LoggedInTime = urlParams.get("LoggedInTime");
      localStorage.setItem("LoggedInTime", LoggedInTime);

      var fullname = urlParams.get("fullname");
      localStorage.setItem("name", fullname);

      // var UserRoles = urlParams.get("UserRoles");
      // UserRoles = UserRoles.replace(/\s+/g, ''); 
      // localStorage.setItem("userRoles", UserRoles);

      var joinedDate = urlParams.get("JoinedDate");
      localStorage.setItem("joinedDate", joinedDate);
      console.log(localStorage.getItem("joinedDate"));

      var mail = urlParams.get("email");
      localStorage.setItem("email", mail);
      console.log("session login 22");
      window.location.href = window.location.origin;
    } else if (localStorage.getItem("empNumber") === null) {
      console.log("session login 23");
      processUserLogin();
    }
    if (localStorage.getItem("isAuthorized") == false) {
      processUserLogin();
    }
    // check emp id exists and valid
    if (localStorage.getItem("empNumber") !== null) {
      console.log("session login 24");
      if (!isPlannedOutage(localStorage.getItem("empNumber"))) {
        console.log("session login 25");
        if (!localStorage.getItem("userSessionId")) {
          console.log("session login 26");
          let userSessionId = uuidv4();
          localStorage.setItem("userSessionId", userSessionId);
        }
        if (localStorage.getItem("isUserLoggedIn") == "1") {
          console.log("session login 27");
          sessionTimeOut();
        } else {
          console.log("session login 28");
          var epochLS = localStorage.getItem("LoggedInTime");
          var begin = epochLS != null ? parseInt(epochLS) : 0;
          var epochDate = begin + 120;
          const now = new Date();
          //const ew = Math.floor(now.getTime() / 1000);
          // let getUserLoginTimeURL = getURL_GetUserLoginTime();
          let ew = await getURL_GetUserLoginTime();
          ew = ew.data;
          if (!(begin < ew && ew < epochDate)) {
            localStorage.removeItem("name");
            localStorage.removeItem("mail");
            localStorage.removeItem("empNumber");
            localStorage.removeItem("LoggedInTime");
            localStorage.removeItem("authorization");
            localStorage.removeItem("isAuthorized");

            window.location.href = process.env.REACT_APP_AUTH_URL;
            return;
          }
          localStorage.setItem("isUserLoggedIn", 1);
        }

        if (urlParams.has("u")) {
          console.log("session login 31");
          window.location.href = window.location.origin;
        }
        if (window.location.href.includes("relogin")) {
          processUserLogin();
        }
      }
    }
  };


  return data?.isLoggingIn ? (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  ) : (
    <>
      <div>
        <ToastContainer autoClose={2000} className={"toaster"} closeOnClick={true} />
      </div>
      <RoutesComponent />
    </>
  );
  // <>
  //
  //   <RoutesComponent />
  // </>
};

export default App;
